import debounce from 'lodash.debounce';
import eventListeners from './event-listeners';
import contentEditable from '../../content-editable';

const keyUpListener = (element) => {
  eventListeners.add(element, 'keyup', debounce(contentEditable.handlers.keyUpHandler, 300));
};

export default keyUpListener;
